import React from 'react';
import {
  Alert,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import type { ProductoDepositoDto, ProductoDepositosLabels } from '../../services/productoDepositoService';

interface Props {
  depositos: ProductoDepositoDto[];
  labels: ProductoDepositosLabels;
  onChange: (depositos: ProductoDepositoDto[]) => void;
  disabled?: boolean;
  esAlta?: boolean;
}

const ProductoDepositosSection: React.FC<Props> = ({
  depositos,
  labels,
  onChange,
  disabled,
  esAlta,
}) => {
  const update = (nroUbicacion: number, patch: Partial<ProductoDepositoDto>) => {
    onChange(depositos.map((d) => (d.nroUbicacion === nroUbicacion ? { ...d, ...patch } : d)));
  };

  return (
    <Stack spacing={2} sx={{ mt: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Ubicación
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Indicá en qué parte del depósito está la mercadería. Son textos de referencia; no asignan ni modifican stock.
      </Typography>
      {esAlta ? (
        <Alert severity="info">
          Las ubicaciones se persisten al pulsar Guardar.
        </Alert>
      ) : null}
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Depósito</TableCell>
              <TableCell width={160}>{labels.ubicacion1}</TableCell>
              <TableCell width={160}>{labels.ubicacion2}</TableCell>
              <TableCell width={160}>{labels.ubicacion3}</TableCell>
              <TableCell width={160}>{labels.ubicacion4}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {depositos.map((row) => (
              <TableRow key={row.nroUbicacion}>
                <TableCell>
                  {row.nombreUbicacion
                    ? `${row.nombreUbicacion} (${row.nroUbicacion})`
                    : `Depósito (${row.nroUbicacion})`}
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={row.ubicacion1 ?? ''}
                    disabled={disabled}
                    onChange={(e) => update(row.nroUbicacion, { ubicacion1: e.target.value })}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={row.ubicacion2 ?? ''}
                    disabled={disabled}
                    onChange={(e) => update(row.nroUbicacion, { ubicacion2: e.target.value })}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={row.ubicacion3 ?? ''}
                    disabled={disabled}
                    onChange={(e) => update(row.nroUbicacion, { ubicacion3: e.target.value })}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    fullWidth
                    value={row.ubicacion4 ?? ''}
                    disabled={disabled}
                    onChange={(e) => update(row.nroUbicacion, { ubicacion4: e.target.value })}
                  />
                </TableCell>
              </TableRow>
            ))}
            {depositos.length === 0 && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Typography variant="body2" color="text.secondary">
                    No hay depósitos para asignar ubicación.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};

export default ProductoDepositosSection;
